module.exports = __webpack_public_path__ + "img/logo.cd5db5b1.svg";